import * as S from './styled'

export type IconCardProps = {
  description: string
  icon: string
  title: string
}

export function IconCard({
  description,
  icon = 'card-panel',
  title
}: IconCardProps) {
  return (
    <S.IconCard>
      <S.Title>{title}</S.Title>
      <S.Subtitle>
        <S.Icon icon={icon} height={32} width={32} />
        <S.Description>{description}</S.Description>
      </S.Subtitle>
    </S.IconCard>
  )
}
